import { render, staticRenderFns } from "./DetalhesFinalizacaoPrintPdf.vue?vue&type=template&id=f5cf21fc"
import script from "./DetalhesFinalizacaoPrintPdf.vue?vue&type=script&lang=js"
export * from "./DetalhesFinalizacaoPrintPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports